import React, { useContext } from "react";
import VGaurdLogo from "../../../assets/images/logoLogin.svg";
import LoginBanner from "../../../assets/images/loginBanner.svg";
import Tick from "../../../assets/images/tick.svg";
import { Col, Row } from "react-bootstrap";
import { EmailVerificationContext } from "../EmailVerificationView";
import "./emailVerfication.css";
const EmailVerificationPage = ({ textContants }) => {
  const { text, resetPassword } = useContext(EmailVerificationContext);
  return (
    <Row>
      <Col lg={6} className="emailVerficationDiv">
        <div className="mainEmailContainer">
          <div className="emailVerficationVgaurdLogo">
            <img src={VGaurdLogo} />
          </div>
          <div className="verficationBox">
            <img src={Tick} alt="Tick" />
            <label className="labelCheckEmail">
              {textContants.checkYourEmail}
            </label>
            <div className="alertMessageBox">
              <label className="labelAlertMessage">
                {textContants.verficationTextMessage}
              </label>
              <label className="labelMessage">
                on your registered email address
              </label>
            </div>
          </div>
        </div>
      </Col>
      <Col lg={6} className="emailVerificationBannerDiv">
        <img className="forgotImgBanner" src={LoginBanner} />
      </Col>
    </Row>
  );
};
export default EmailVerificationPage;
